import { Box, Avatar, Typography } from '@mui/material';
import React from 'react';

type StatusesWrapperProps = {
  iconUrl: string;
  name: string;
  description?: string;
  statusColor?: string;
};

export default function StatusesWrapper({
  iconUrl,
  name,
  description,
  statusColor = 'black',
}: StatusesWrapperProps) {
  return (
    <Box display='flex' alignItems='center' gap={2}>
      <Avatar sx={{ width: 32, height: 32 }} src={iconUrl} alt={name} />
      <Typography
        sx={{
          color: statusColor,
        }}
      >
        {name}
      </Typography>
    </Box>
  );
}
